import {
  createPlugin,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { quickStartApiRef, QuickStartApiClient } from './api';
import { rootRouteRef } from './routes';

/**
 * Quick Start plugin for Backstage
 *
 * @public
 */
export const quickStartPlugin = createPlugin({
  id: 'quick-start',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: quickStartApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new QuickStartApiClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/**
 * The Quick Start page component
 *
 * @public
 */
export const QuickStartPage = quickStartPlugin.provide(
  createRoutableExtension({
    name: 'QuickStartPage',
    component: () =>
      import('./components/QuickStartPage').then(m => m.QuickStartPage),
    mountPoint: rootRouteRef,
  }),
);
